import { SurfaceType } from "@/enums/SurfaceType";

export class Field {
    name: string = "Length";
    value !: number;
    constructor(fieldName: string, fieldValue: any) {
        this.name = fieldName;
        this.value = fieldValue;
    }
}